import * as React from 'react';

import { createIcon } from '../Icon';
export const MoreVerticalIcon = createIcon(
  <React.Fragment>
    <circle cx={12} cy={12} r={1} />
    <circle cx={12} cy={5} r={1} />
    <circle cx={12} cy={19} r={1} />
  </React.Fragment>,
  'MoreVerticalIcon'
);
